const themeColor = [
    { 
        id: 0, 
        name: "red",
        color1: " bg-red-600 ",
        color2: " bg-red-500 ",
        hover1: " hover:bg-red-300 "
    },
    { 
        id: 1, 
        name: "orange",
        color1: " bg-orange-600 ",
        color2: " bg-orange-500 ",
        hover1: " hover:bg-orange-300 "
    },
    { 
        id: 2,
        name: "green",
        color1: " bg-lime-900 ",
        color2: " bg-lime-700 ",
        hover1: " hover:bg-lime-500 "
    },
    { 
        id: 3,
        name: "cyan",
        color1: " bg-cyan-900 ",
        color2: " bg-cyan-700 ",
        hover1: " hover:bg-cyan-300 "
    },
    { 
        id: 4,
        name: "violet",
        color1: " bg-purple-900 ",
        color2: " bg-purple-700 ",
        hover1: " hover:bg-violet-300 "
    },
    { 
        id: 5,
        name: "pink",
        color1: " bg-rose-400 ",
        color2: " bg-rose-300 ",
        hover1: " hover:bg-rose-200 "
    },
    { 
        id: 6,
        name: "slate",
        color1: " bg-slate-700 ",
        color2: " bg-slate-500 ",
        hover1: " hover:bg-gray-300 "
    },
    { 
        id: 6,
        name: "gray",
        color1: " bg-neutral-800 ",
        color2: " bg-neutral-700 ",
        hover1: " hover:bg-neutral-500 "
    }

];

export default themeColor; 